module.exports = require('./helpers/bundle-url').getBundleURL('2LpMj') + "driver_phone_dark.f05bbc1b.png" + "?" + Date.now();